import { cn } from "@/lib/utils";

interface TabProgressIndicatorProps {
  className?: string;
  style?: React.CSSProperties;
}

export function TabProgressIndicator({
  className,
  style,
}: TabProgressIndicatorProps) {
  return (
    <div
      className={cn(
        "absolute -bottom-[8px] h-[4px] transition-all duration-300 ease-out z-10 rounded-t-full",
        className
      )}
      style={{
        background: "var(--heading-gradient)",
        ...style,
      }}
    />
  );
}
